import React, {Component} from "react";
import SportIcon from "../SportIcon";
import Popular from "./Popular";
import Link from "react-router-dom/es/Link";
import ObjectHelper from "../../helpers/ObjectHelper";
import {connect} from "react-redux";
import lodash from "lodash";

class Sport extends Component {
	state = {
		elemOpened : false,
		populars   : [],
		selected   : [],
		reference  : ''
	};

	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleFirstLevel = this.handleFirstLevel.bind(this);
	}

	handleClick(event) {
		event.preventDefault();
		this.setState({
			elemOpened : !this.state.elemOpened
		});
	}

	handleFirstLevel(e) {
		const key = e.target.value;
		let data = this.state.selected;
		data = ObjectHelper.toggleData(data, key);

		this.setState({
			selected : data
		});
	}

	render() {
		const {populars} = this.props.line.populars;
		const sortedPopulars = lodash.sortBy(populars, p => p.name);
		let action = `/popular/${Object.keys(this.state.selected).join("-")}`;

		const data = sortedPopulars.map((popular) => {
			const filteredLeagues = this.props.leagues.filter((league) => {return league.popular_id === popular.id});
			if ( filteredLeagues.length > 0 ) {
				return <Popular key={`${this.props.sport.id}_${popular.id}`}
				                popular={popular}
				                leagues={filteredLeagues}
				                sport={this.props.sport}
				                handleChange={this.handleFirstLevel}/>;

			}
		});

		return (
			<div>
				<li onClick={this.handleClick} className={this.state.elemOpened ? 'opened' : ''}>
					<span className="top-event-list__icon">
						<span className="sport-icon small green">
							<SportIcon sportId={parseInt(this.props.sport.id)}/>
						</span>
					</span>
					<span>{this.props.sport.name}</span>
					<a className={`top-event-list__plus ${this.state.elemOpened ? 'minus' : 'plus'}`}>
						<i className={`fas ${this.state.elemOpened ? 'fa-minus' : 'fa-plus'}`}></i>
					</a>
				</li>

				<div className={`top-event-list__sub ${this.state.elemOpened && 'show'}`}>
					<form name="leagues-form" method="get">
						<ul className="top-event-list__sub-leagues leagues">
							{data}
						</ul>
						<div className="buttons">
							<Link to={action} className="buttons__show">Показать</Link>
							<button className="buttons__clear" type="reset">Очистить</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		line : state.line
	}),
	dispatch => ({})
)(Sport);


// WEBPACK FOOTER //
// ./src/app/components/TopEvents/Sport.js